<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                        <Description term="收款记录：">
                          <Tag class="cursor" v-for="(item,idx) in detail.expend_sn" :key="idx" color="orange" >{{item}}</Tag>
                        </Description>
                        <Description term="状态：">
                            <Badge v-if="detail.status === 1" color="blue" text="待审核" />
                            <Badge v-else-if="detail.status === 2" color="red" text="已驳回" />
                            <Badge v-else-if="detail.status === 3" color="green" text="已开票" />
                            <Badge v-else color="#999999" text="其他" />
                        </Description>
                        <Description term="开票金额：">
                            <Tag color="blue">{{detail.inv_money}}</Tag>
                        </Description>
                        <Description term="开票公司：">
                            {{detail.company}}
                        </Description>
                        <Description term="绑定金额：">
                            <Tag color="green">{{detail.use_inv_money}}</Tag>
                        </Description>
                        <Description term="发票类型：">
                            <Tag>{{detail.inv_type_name}}</Tag>
                        </Description>

                        <Description term="驳回原因：" v-if="detail.status === 2">
                            {{detail.object_remark}}
                        </Description>
                        <Description term="驳回时间：" v-if="detail.status === 2">
                            {{detail.object_time}}
                        </Description>
                        <Description term="申请人：">
                            {{detail.apply_name}}
                        </Description>
                        <Description term="申请时间：">
                            {{detail.apply_time}}
                        </Description>
                      <Description term="发票：" :col="1"  layout="vertical">
                        <a href="javascript:void(0);" @click="FileDownload(detail.invoice_image)">下载文件</a>
                      </Description>
                    </DescriptionList>

                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                        <Description term="备注信息：">
                            {{detail.remark}}
                        </Description>
                    </DescriptionList>
                </Col>
            </Row>
        </div>
    </Drawer>
</template>

<script>

import {getExpendInvoiceDetail} from "@/apis/invoice/expend";

export default {
    name: 'ExpendInvoiceShow',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '发票详情',
            isBox : false,
          site_url : this.$siteApi,
            detail: []
        }
    },
    methods: {

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(inv_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendInvoiceDetail(inv_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(inv_id){
            this.isBox = true;
            if(inv_id){
                this.GetDetail(inv_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.detail = [];
        },
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
